// const POSTS_URL = "http://localhost:8787/API/POSTS";
const POSTS_URL =
    "https://serverless-api.hopefullyanintern.workers.dev/API/POSTS";
// const JWT_URL = "https://bottles-memories-relating-four.trycloudflare.com";

export { POSTS_URL };
